module.exports = __webpack_public_path__ + "static/media/blogThree.ff4d3445.jpg";